import type { DialogBaseProps } from "@freightsimple/ui-core/Dialog/DialogBaseProps";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import CreditCardsAddCreditCardDialog from "@/Features/CreditCards/Dialogs/CreditCardsAddCreditCardDialog";

interface CreditCardsAddDialogProps extends DialogBaseProps {
  /** Fired once the card has been stored so the caller can reload the list. */
  onCardAdded: () => void;
}

// Hosts the add-credit-card form (Stripe card entry + billing address) in a
// dialog. The form owns its own buttons. Replaces the legacy imperative modal.
export function CreditCardsAddDialog(props: CreditCardsAddDialogProps) {
  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      width="medium"
      title="Add Credit Card"
      description="FreightSimple accepts Visa, Mastercard, and American Express"
    >
      <ControlPresentationProvider presentation="underlined">
        {props.open && (
          <CreditCardsAddCreditCardDialog
            onCardAdded={() => {
              props.onOpenChange?.(false);
              props.onCardAdded();
            }}
            onCancel={() => props.onOpenChange?.(false)}
          />
        )}
      </ControlPresentationProvider>
    </Dialog>
  );
}
